var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack4Solid13({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87,9.89l1.54.49a3.47,3.47,0,0,1-1.18,1.91,3.35,3.35,0,0,1-2.09.63,3.39,3.39,0,0,1-2.58-1.07,4.14,4.14,0,0,1-1-2.93,4.34,4.34,0,0,1,1-3.06A3.51,3.51,0,0,1,8.23,4.77a3.27,3.27,0,0,1,2.35.86,3.07,3.07,0,0,1,.81,1.45l-1.58.37a1.62,1.62,0,0,0-.58-1,1.66,1.66,0,0,0-1.08-.36,1.8,1.8,0,0,0-1.42.63,3.11,3.11,0,0,0-.54,2,3.34,3.34,0,0,0,.53,2.12,1.74,1.74,0,0,0,1.4.64,1.63,1.63,0,0,0,1.09-.4A2.39,2.39,0,0,0,9.87,9.89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack4Solid13);
export default __webpack_public_path__ + "static/media/Symbolpack_4_solid_13.72977b65f03af58099f75e7e4a446888.svg";
export { ForwardRef as ReactComponent };